import React from 'react'
import SbEditable from 'storyblok-react'
import Video from '../atoms/Video'

const FullscreenVideoBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`content-block-full-width ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''}`}
      >
        <figure>
          <div className="figmedia">
            <Video video={block.video} _uid={block._uid} />
          </div>
          {block.caption?.length > 0 && (
            <figcaption>{block.caption}</figcaption>
          )}
        </figure>
      </section>
    </SbEditable>
  )
}

export default FullscreenVideoBlock
